import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './Countdown';
import { Shield, Lock, CreditCard, Zap, Star } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="bg-dark-900 py-12 px-4 relative overflow-hidden" data-id="element-154">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-primary/10 rounded-full blur-[150px] pointer-events-none" data-id="element-155"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-156">
        <div className="text-center mb-8" data-id="element-157">
          <h2 className="text-lg md:text-3xl font-bold mb-4 flex items-center justify-center text-gold" data-id="element-158">
            <span className="mr-2" data-id="element-159">⏰</span> PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <Countdown data-id="element-160" />
          <p className="text-cream/80 mt-3 flex items-center justify-center text-sm md:text-base" data-id="element-161">
            <span className="text-urgency mr-2" data-id="element-162">⚠️</span> Después sube $8.000
            ARS. No vuelve.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10" data-id="element-163">
          <div className="flex justify-between text-sm mb-2 text-cream/90 font-medium" data-id="element-164">
            <span className="flex items-center" data-id="element-165">
              <span className="w-2 h-2 rounded-full bg-urgency mr-2 animate-pulse" data-id="element-166"></span>
              Cupos al precio de lanzamiento
            </span>
            <span data-id="element-167">68%</span>
          </div>
          <div className="w-full bg-dark-800 rounded-full h-3 overflow-hidden border border-primary/30" data-id="element-168">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="bg-gradient-to-r from-primary to-urgency h-3 rounded-full" data-id="element-169"></motion.div>
          </div>
          <p className="text-xs text-center text-cream/50 mt-2" data-id="element-170">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>

        <h3 className="text-xl md:text-3xl font-bold text-center text-cream mb-6 flex items-center justify-center" data-id="element-171">
          <CreditCard className="w-6 h-6 md:w-8 md:h-8 mr-2 md:mr-3 text-primary" data-id="element-172" />{' '}
          ELEGÍ TU MÉTODO
        </h3>

        <div className="grid grid-cols-2 gap-3 md:gap-6 max-w-3xl mx-auto mb-10" data-id="element-173">
          <motion.div whileHover={{
          y: -8
        }} className="bg-dark-800 rounded-xl md:rounded-2xl p-3 md:p-6 border border-primary/40 flex flex-col h-full shadow-xl" data-id="element-174">
            <div className="text-center mb-2 md:mb-4" data-id="element-175">
              <h4 className="text-sm md:text-xl font-bold text-cream mb-1 md:mb-2 flex items-center justify-center" data-id="element-176">
                <span className="mr-1 md:mr-2" data-id="element-177">📘</span> MÉTODO
              </h4>
              <p className="font-semibold mb-1 md:mb-3 text-primary text-[10px] md:text-sm" data-id="element-178">
                MENTE ENFOCADA
              </p>
              <p className="text-cream/80 text-[10px] md:text-sm mb-2 md:mb-4" data-id="element-179">
                6 Tomos + 6 Bonos
              </p>
              <div className="bg-dark-900 rounded-lg py-1 px-2 md:py-2 md:px-3 inline-block mb-2 md:mb-4 border border-primary/30" data-id="element-180">
                <p className="text-[9px] md:text-xs text-cream/70" data-id="element-181">
                  Ideal para:
                </p>
                <p className="text-[10px] md:text-sm font-medium text-cream" data-id="element-182">
                  Familias con niños de 4 a 12 años
                </p>
              </div>
            </div>

            <div className="text-center mb-3 md:mb-6 flex-grow" data-id="element-183">
              <p className="line-through text-xs md:text-lg mb-1 md:mb-2 text-gold" data-id="element-184">
                $51.000
              </p>
              <div className="flex items-start justify-center" data-id="element-185">
                <span className="text-sm md:text-xl text-cta mt-1 md:mt-2 mr-0.5 md:mr-1" data-id="element-186">
                  $
                </span>
                <span className="text-2xl md:text-5xl font-bold text-cta" data-id="element-187">
                  14.990
                </span>
                <span className="text-[10px] md:text-lg text-cta mt-auto mb-1 md:mb-2 ml-0.5 md:ml-1" data-id="element-188">
                  ARS
                </span>
              </div>
            </div>

            <a href="https://www.digitalbibliotec.online/cart/52212299890970:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-primary hover:bg-primary-dark text-white font-bold py-2 md:py-3 px-2 md:px-5 rounded-full transition-all mb-1 text-center text-[10px] md:text-sm leading-tight" data-id="element-189">
              👉 QUIERO EL MÉTODO AHORA
            </a>
          </motion.div>

          <motion.div whileHover={{
          y: -8
        }} className="bg-gradient-to-b from-primary-dark to-dark-800 rounded-xl md:rounded-2xl p-3 md:p-6 border-2 border-gold flex flex-col h-full shadow-[0_0_30px_rgba(245,158,11,0.2)] relative" data-id="element-190">
            <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-gold text-dark-900 font-bold py-0.5 md:py-1 px-2 md:px-4 rounded-full text-[9px] md:text-sm flex items-center shadow-lg whitespace-nowrap" data-id="element-191">
              <Star className="w-3 h-3 md:w-4 md:h-4 mr-0.5 md:mr-1 fill-dark-900" data-id="element-192" />{' '}
              MÁS ELEGIDO
            </div>

            <div className="text-center mb-2 md:mb-4 mt-2" data-id="element-193">
              <h4 className="text-sm md:text-xl font-bold text-cream mb-1 md:mb-2 flex items-center justify-center" data-id="element-194">
                <span className="mr-1 md:mr-2" data-id="element-195">🏆</span> MÉTODO +
              </h4>
              <p className="text-gold font-bold mb-1 md:mb-3 text-[10px] md:text-sm" data-id="element-196">
                MENTE BLINDADA
              </p>
              <p className="text-cream/90 text-[10px] md:text-sm mb-2 md:mb-4 font-medium" data-id="element-197">
                6 Tomos + 6 Bonos + Kit Premium
              </p>
              <div className="bg-dark-900/50 rounded-lg py-1 px-2 md:py-2 md:px-3 inline-block mb-2 md:mb-4 border border-gold/30" data-id="element-198">
                <p className="text-[9px] md:text-xs text-cream/70" data-id="element-199">
                  Ideal para:
                </p>
                <p className="text-[10px] md:text-sm font-medium text-cream" data-id="element-200">
                  Niños con dificultades de atención o dependencia severa
                </p>
              </div>
            </div>

            <div className="text-center mb-3 md:mb-6 flex-grow" data-id="element-201">
              <p className="line-through text-xs md:text-lg mb-1 md:mb-2 text-gold" data-id="element-202">
                $69.000
              </p>
              <div className="flex items-start justify-center" data-id="element-203">
                <span className="text-sm md:text-xl text-cta mt-1 md:mt-2 mr-0.5 md:mr-1" data-id="element-204">
                  $
                </span>
                <span className="text-2xl md:text-5xl font-bold text-cta" data-id="element-205">
                  24.990
                </span>
                <span className="text-[10px] md:text-lg text-cta mt-auto mb-1 md:mb-2 ml-0.5 md:ml-1" data-id="element-206">
                  ARS
                </span>
              </div>
            </div>

            <a href="https://www.digitalbibliotec.online/cart/52212305330458:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-cta hover:bg-cta-hover text-white font-bold py-2 md:py-3 px-2 md:px-5 rounded-full shadow-[0_0_20px_rgba(16,185,129,0.4)] transition-all mb-1 text-center text-[10px] md:text-sm leading-tight" data-id="element-207">
              👉 MÉTODO + MENTE BLINDADA
            </a>
          </motion.div>
        </div>

        <div className="flex flex-wrap justify-center gap-5 md:gap-8 text-sm text-cream/70 bg-dark-800/50 py-4 px-6 rounded-2xl border border-primary/30 max-w-3xl mx-auto" data-id="element-208">
          <div className="flex items-center" data-id="element-209">
            <Lock className="w-5 h-5 mr-2 text-primary" data-id="element-210" /> Pago 100% seguro
          </div>
          <div className="flex items-center" data-id="element-211">
            <Zap className="w-5 h-5 mr-2 text-gold" data-id="element-212" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center" data-id="element-213">
            <Shield className="w-5 h-5 mr-2 text-primary" data-id="element-214" /> Garantía 7 días
          </div>
          <div className="flex items-center" data-id="element-215">
            <CreditCard className="w-5 h-5 mr-2 text-primary" data-id="element-216" /> Mercado Pago |
            Tarjeta | Transferencia
          </div>
        </div>
      </div>
    </section>;
}